declare global {
    interface Window {
        env: any
    }
}

// change with your own variables
type EnvType = {
    readonly REACT_APP_CONFIGURATOR_BASEURL: string;
    readonly REACT_APP_DATABRIDGE_BASEURL: string;
    readonly REACT_APP_COOKIE_DOMAIN: string;
    readonly REACT_APP_COOKIE_NAME: string;
    readonly REACT_APP_JWT_NAME: string;
}

export const env: EnvType = { ...window.env }